/**
 * Created by asiulik on 19.05.2017.
 */

define(function(){

    return {

        neosBodyClass: '.neos-backend',
        changePageConst: {
            global: {
                content: "#content"
            },
            default: {
                animationDuration: 400,
                contentClassEnd: "content--end",
                contentClassLoaded: "content--loaded",
                contentClassLoading: "content--loading",
                contentClassDone: "content--done",
                contentClassFail: "content--fail"
            },
            teaserExpand: {
            }
        }
    }

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/pageConst.js